<template>
      <header style="background-color: #F8F8F8">
      <div class="d-flex justify-content-between p-2">
        <a  class="lang" style="padding: 5px"
          ><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a class="p-2" style="font-size: 18px">
          <i class="fa fa-bell-o" aria-hidden="true"></i
        ></a>
        <a class="p-2" style="font-size: 18px">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i
        ></a>
      </div>
    </header>
</template>